import { getSlotClass } from '@/core/utils/utils';
import {
  ComponentType,
  Slot,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'ModuleItem',
  props: {
    theSlot: {
      type: Object as PropType<Slot>,
      required: true,
    },
  },
})
export default class ModuleItem extends Vue {
  theSlot!: Slot;

  get slotClass() {
    const theClass = getSlotClass(this.theSlot);
    return `slot-indicator--${theClass}`;
  }

  get slotName() {
    return this.theSlot.assignedComponentType === ComponentType.Command
      ? `${this.$t('AppResource.Module')} ${this.theSlot.index}`
      : `${this.$t('AppResource.Channel')} ${ this.theSlot.index}`
  }

  get linkDescription() {
    if (this.theSlot.linkedObjects && this.theSlot.linkedObjects.length > 0)
      return `${this.$t('AppResource.LinkedWith')} ${
        this.theSlot.linkedObjects[0].name
      }`;
    else return '';
  }
}
